"use strict";

var _classCallCheck = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TransactionHelper = void 0;

var AccountAddressRestrictionTransactionBuilder_1 = require("./AccountAddressRestrictionTransactionBuilder");

var AccountKeyLinkTransactionBuilder_1 = require("./AccountKeyLinkTransactionBuilder");

var AccountMetadataTransactionBuilder_1 = require("./AccountMetadataTransactionBuilder");

var AccountMosaicRestrictionTransactionBuilder_1 = require("./AccountMosaicRestrictionTransactionBuilder");

var AccountOperationRestrictionTransactionBuilder_1 = require("./AccountOperationRestrictionTransactionBuilder");

var AddressAliasTransactionBuilder_1 = require("./AddressAliasTransactionBuilder");

var AggregateBondedTransactionBuilder_1 = require("./AggregateBondedTransactionBuilder");

var AggregateCompleteTransactionBuilder_1 = require("./AggregateCompleteTransactionBuilder");

var HashLockTransactionBuilder_1 = require("./HashLockTransactionBuilder");

var MosaicAddressRestrictionTransactionBuilder_1 = require("./MosaicAddressRestrictionTransactionBuilder");

var MosaicAliasTransactionBuilder_1 = require("./MosaicAliasTransactionBuilder");

var MosaicDefinitionTransactionBuilder_1 = require("./MosaicDefinitionTransactionBuilder");

var MosaicGlobalRestrictionTransactionBuilder_1 = require("./MosaicGlobalRestrictionTransactionBuilder");

var MosaicMetadataTransactionBuilder_1 = require("./MosaicMetadataTransactionBuilder");

var MosaicSupplyChangeTransactionBuilder_1 = require("./MosaicSupplyChangeTransactionBuilder");

var MultisigAccountModificationTransactionBuilder_1 = require("./MultisigAccountModificationTransactionBuilder");

var NamespaceMetadataTransactionBuilder_1 = require("./NamespaceMetadataTransactionBuilder");

var NamespaceRegistrationTransactionBuilder_1 = require("./NamespaceRegistrationTransactionBuilder");

var NodeKeyLinkTransactionBuilder_1 = require("./NodeKeyLinkTransactionBuilder");

var SecretLockTransactionBuilder_1 = require("./SecretLockTransactionBuilder");

var SecretProofTransactionBuilder_1 = require("./SecretProofTransactionBuilder");

var TransactionBuilder_1 = require("./TransactionBuilder");

var TransferTransactionBuilder_1 = require("./TransferTransactionBuilder");

var VotingKeyLinkTransactionBuilder_1 = require("./VotingKeyLinkTransactionBuilder");

var VrfKeyLinkTransactionBuilder_1 = require("./VrfKeyLinkTransactionBuilder");

var TransactionHelper = /*#__PURE__*/function () {
  function TransactionHelper() {
    _classCallCheck(this, TransactionHelper);
  }

  _createClass(TransactionHelper, null, [{
    key: "loadFromBinary",
    value: function loadFromBinary(payload) {
      var header = TransactionBuilder_1.TransactionBuilder.loadFromBinary(payload);

      if (header.type === 16716 && header.version === 1) {
        return AccountKeyLinkTransactionBuilder_1.AccountKeyLinkTransactionBuilder.loadFromBinary(payload);
      }

      if (header.type === 16972 && header.version === 1) {
        return NodeKeyLinkTransactionBuilder_1.NodeKeyLinkTransactionBuilder.loadFromBinary(payload);
      }

      if (header.type === 16705 && header.version === 1) {
        return AggregateCompleteTransactionBuilder_1.AggregateCompleteTransactionBuilder.loadFromBinary(payload);
      }

      if (header.type === 16961 && header.version === 1) {
        return AggregateBondedTransactionBuilder_1.AggregateBondedTransactionBuilder.loadFromBinary(payload);
      }

      if (header.type === 16707 && header.version === 1) {
        return VotingKeyLinkTransactionBuilder_1.VotingKeyLinkTransactionBuilder.loadFromBinary(payload);
      }

      if (header.type === 16963 && header.version === 1) {
        return VrfKeyLinkTransactionBuilder_1.VrfKeyLinkTransactionBuilder.loadFromBinary(payload);
      }

      if (header.type === 16712 && header.version === 1) {
        return HashLockTransactionBuilder_1.HashLockTransactionBuilder.loadFromBinary(payload);
      }

      if (header.type === 16722 && header.version === 1) {
        return SecretLockTransactionBuilder_1.SecretLockTransactionBuilder.loadFromBinary(payload);
      }

      if (header.type === 16978 && header.version === 1) {
        return SecretProofTransactionBuilder_1.SecretProofTransactionBuilder.loadFromBinary(payload);
      }

      if (header.type === 16708 && header.version === 1) {
        return AccountMetadataTransactionBuilder_1.AccountMetadataTransactionBuilder.loadFromBinary(payload);
      }

      if (header.type === 16964 && header.version === 1) {
        return MosaicMetadataTransactionBuilder_1.MosaicMetadataTransactionBuilder.loadFromBinary(payload);
      }

      if (header.type === 17220 && header.version === 1) {
        return NamespaceMetadataTransactionBuilder_1.NamespaceMetadataTransactionBuilder.loadFromBinary(payload);
      }

      if (header.type === 16717 && header.version === 1) {
        return MosaicDefinitionTransactionBuilder_1.MosaicDefinitionTransactionBuilder.loadFromBinary(payload);
      }

      if (header.type === 16973 && header.version === 1) {
        return MosaicSupplyChangeTransactionBuilder_1.MosaicSupplyChangeTransactionBuilder.loadFromBinary(payload);
      }

      if (header.type === 16725 && header.version === 1) {
        return MultisigAccountModificationTransactionBuilder_1.MultisigAccountModificationTransactionBuilder.loadFromBinary(payload);
      }

      if (header.type === 16974 && header.version === 1) {
        return AddressAliasTransactionBuilder_1.AddressAliasTransactionBuilder.loadFromBinary(payload);
      }

      if (header.type === 17230 && header.version === 1) {
        return MosaicAliasTransactionBuilder_1.MosaicAliasTransactionBuilder.loadFromBinary(payload);
      }

      if (header.type === 16718 && header.version === 1) {
        return NamespaceRegistrationTransactionBuilder_1.NamespaceRegistrationTransactionBuilder.loadFromBinary(payload);
      }

      if (header.type === 16720 && header.version === 1) {
        return AccountAddressRestrictionTransactionBuilder_1.AccountAddressRestrictionTransactionBuilder.loadFromBinary(payload);
      }

      if (header.type === 16976 && header.version === 1) {
        return AccountMosaicRestrictionTransactionBuilder_1.AccountMosaicRestrictionTransactionBuilder.loadFromBinary(payload);
      }

      if (header.type === 17232 && header.version === 1) {
        return AccountOperationRestrictionTransactionBuilder_1.AccountOperationRestrictionTransactionBuilder.loadFromBinary(payload);
      }

      if (header.type === 16977 && header.version === 1) {
        return MosaicAddressRestrictionTransactionBuilder_1.MosaicAddressRestrictionTransactionBuilder.loadFromBinary(payload);
      }

      if (header.type === 16721 && header.version === 1) {
        return MosaicGlobalRestrictionTransactionBuilder_1.MosaicGlobalRestrictionTransactionBuilder.loadFromBinary(payload);
      }

      if (header.type === 16724 && header.version === 1) {
        return TransferTransactionBuilder_1.TransferTransactionBuilder.loadFromBinary(payload);
      }

      return header;
    }
  }]);

  return TransactionHelper;
}();

exports.TransactionHelper = TransactionHelper;